/**
 * FuturizerLogo
 * Props:
 *   size    – logo height in px (default 40)
 *   variant – 'full' | 'icon' | 'white-full' | 'white-icon'
 *
 * 'full' / 'icon'        → used on light backgrounds
 * 'white-full' / 'white-icon' → used on dark backgrounds (adds white pill)
 */
export default function FuturizerLogo({ size = 40, variant = 'full' }) {
  const onDark = variant === 'white-full' || variant === 'white-icon';

  const img = (
    <img
      src="/futurize-logo.png"
      alt="Futurize PB"
      style={{
        height: size,
        width: 'auto',
        display: 'block',
        objectFit: 'contain',
      }}
    />
  );

  if (onDark) {
    return (
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          background: '#ffffff',
          borderRadius: Math.round(size * 0.18),
          padding: `${Math.round(size * 0.1)}px ${Math.round(size * 0.2)}px`,
          lineHeight: 0,
        }}
      >
        {img}
      </div>
    );
  }

  return img;
}
